import React, { useState, useEffect, useContext } from 'react'
import { Box, List, ListItem } from '@mui/joy';

import { useTranslation } from 'react-i18next';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { BookingAvatar, DocumentAvatar, DrivingLicenceAvatar, PersonAvatar, ServiceAvatar, Text, useDrawer, WidgetCalendarBooking, WidgetMultiCalendarBooking } from 'src/mtska-frontend-app-component';
import { VehicleCard, VehicleCardFromView } from '../../Car/views';
import VehicleConfigurationCard from '../../Car/views/VehicleConfigurationCard';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const Driver = () => {
    const { t } = useTranslation();
    const { activate } = useDrawer();

    const { appConfiguration } = useContext(AppContext);

    const { item: user } = useDataProvider('auth/token');
    const { loadAll: loadAllWhoAmI, items: myPerson } = useDataProvider('persons/person/whoami');
    const { loadAll: loadAllMyEmployment, items: myEmployment } = useDataProvider('persons/person/employment');
    const { loadAll: loadAllMyDocuments, items: myDocuments } = useDataProvider('persons/person/documents');
    const { loadAll: loadAllMyCars, items: myCars, total: myCarsTotal } = useDataProvider('cars/car');
    const { loadAll: loadAllMyServices, items: myServices } = useDataProvider('persons/person/services');
    const { loadAll: loadAllMyBookings, items: myBookings } = useDataProvider('persons/person/bookings');
    const { loadAll: loadAllMyConfigurations, items: myConfigurations } = useDataProvider('persons/person/configurations');

    const [hasPoolCar, setHasPoolCar] = useState(false);
    const [selectedCalendarId, setSelectedCalendarId] = useState(null);

    useEffect(() => {
        loadAllWhoAmI().then(() => {
            loadAllMyEmployment();
            loadAllMyDocuments();
            loadAllMyCars();
            loadAllMyServices();
            loadAllMyBookings();
        });
    }, [user]);

    useEffect(() => {
        const poolcars = myCars.find(car => car.isPool === "true");
        // console.info(poolcars);

        setHasPoolCar(myCars.some(car => car.isPool === "true"));
    }, [myCars]);

    useEffect(() => {
        if (
            myEmployment &&
            myEmployment.hasOwnProperty('fleetConfigurationActive') &&
            myEmployment?.fleetConfigurationActive &&
            myEmployment?.fleetConfigurationActive === 'true' &&
            myEmployment.hasOwnProperty('fleetConfigurationLink') &&
            myEmployment?.fleetConfigurationLink &&
            myEmployment?.fleetConfigurationLink.length > 0 &&
            (myEmployment?.fleetConfigurationLinkValid_at && (new Date(myEmployment?.fleetConfigurationLinkValid_at) < new Date())) &&
            (myEmployment?.fleetConfigurationLinkExpire_at && (new Date(myEmployment?.fleetConfigurationLinkExpire_at) > new Date()))
        ) {
            loadAllMyConfigurations();
        }

        myEmployment.person = myPerson;
    }, [myEmployment]);

    const handlePersonClick = () => {
        activate('persons/detail', { id: myPerson.id });
    }

    const handleDrivingLicenceClick = () => {
        activate('persons/drivingLicenceAssociation', { person: myPerson, personId: myPerson._id, multipart: true, filters: { data: { modelName: 'persons', _id: myPerson._id, keyName: myPerson?.firstname+' '+myPerson?.lastname } } })
    }

    return (
        <Box className="dashboard dashboard-driver">

            <Box className="dashboard-portion-title">{t('Your profile')}</Box>
            <Box className="dashboard-portion-driver-info">
                <PersonAvatar onClick={handlePersonClick} firstname={myPerson?.firstname} lastname={myPerson?.lastname} url={myPerson?.picture?.url} withname={true} detail={user?.data?.email} item={myPerson} />
                {appConfiguration?.custom?.driverDashboard?.showLicence &&
                    <DrivingLicenceAvatar onClick={handleDrivingLicenceClick} drivingLicence={myDocuments?.person?.drivingLicense} />
                }
            </Box>

            {
                myEmployment &&
                myEmployment.hasOwnProperty('fleetConfigurationActive') &&
                myEmployment?.fleetConfigurationActive &&
                myEmployment?.fleetConfigurationActive === 'true' &&
                myEmployment.hasOwnProperty('fleetConfigurationLink') &&
                myEmployment?.fleetConfigurationLink &&
                myEmployment?.fleetConfigurationLink?.length > 0 &&
                (myEmployment?.fleetConfigurationLinkValid_at && (new Date(myEmployment?.fleetConfigurationLinkValid_at) < new Date())) &&
                (myEmployment?.fleetConfigurationLinkExpire_at && (new Date(myEmployment?.fleetConfigurationLinkExpire_at) > new Date())) && (
                    <Box className="dashboard-configuration-wrapper">
                        <Box className="dashboard-configuration-cta">
                            <img src="/images/configuration.webp" />
                            <Box className="dashboard-configuration-cta-inner">
                                <Text level="title-sm">{t('Hurra!')}</Text>
                                <Text level="body-sm">{t('You are elegible to a new configuration, it\'s fun time!')}</Text>
                                <a href={myEmployment?.fleetConfigurationLink} target="_blank" className='MuiButton-colorPrimary MuiButton-variantSolid input-button regular buttonized'>{t('Start')}</a>
                            </Box>
                        </Box>
                    </Box>
                )
            }

            {
                myEmployment?.fleetConfigurationActive &&
                myConfigurations &&
                myConfigurations?.ArrayConfigurazioni &&
                myConfigurations?.ArrayConfigurazioni?.length > 0 && (
                    <Box className="dashboard-configuration-wrapper">
                        <Box className="dashboard-portion-title">{t('Your configurations')}</Box>
                        <Box className="dashboard-portion-subtitle">{t('You have {{myConfigurationsTotal}} configurations', { myConfigurationsTotal: myConfigurations.ArrayConfigurazioni.length })}</Box>

                        <List className="dashboard-portion dashboard-menu">
                            {
                                myConfigurations.ArrayConfigurazioni.map((myConfiguration, k) => (
                                    <ListItem key={k} className="dashboard-portion-item dashboard-configuration-list">
                                        <VehicleConfigurationCard itemview={myConfiguration} />
                                    </ListItem>
                                ))
                            }
                        </List>
                    </Box>
                )
            }

            {
                hasPoolCar && (
                    <Box className="dashboard-portion">
                        <Box className="dashboard-portion-title">{t('Book a pool vehicle')}</Box>
                        <Box sx={{ display: 'flex', gap: '40px' }}>
                            {
                                selectedCalendarId ?
                                    <WidgetCalendarBooking calendar_id={selectedCalendarId} currentDriver={[myEmployment]} /> :
                                    <WidgetMultiCalendarBooking currentDriver={myEmployment} onComplete={loadAllMyBookings} />
                            }
                        </Box>
                    </Box>
                )
            }

            {
                myBookings &&
                myBookings?.length > 0 && (
                    <Box className="dashboard-portion">
                        <Box className="dashboard-portion-title">{t('Your bookings')}</Box>
                        <Box className="dashboard-portion-subtitle">{t('You have {{myBookingsTotal}} upcoming bookings', { myBookingsTotal: myBookings?.length })}</Box>

                        <List className="dashboard-portion dashboard-menu">
                            {
                                myBookings.map((myBooking, k) => (
                                    <ListItem key={k} className="dashboard-portion-item dashboard-vehicle-list">
                                        <BookingAvatar booking={myBooking} loadAll={loadAllMyBookings}/>
                                    </ListItem>
                                ))
                            }
                        </List>
                    </Box>
                )
            }

            {
                myCars &&
                myCars?.length > 0 && (
                    <Box className="dashboard-portion">
                        <Box className="dashboard-portion-title">{t('Your vehicles')}</Box>
                        <Box className="dashboard-portion-subtitle">{t('You have {{myCarsTotal}} vehicles in your garage', { myCarsTotal: myCarsTotal })}</Box>

                        <List className="dashboard-portion dashboard-menu">
                            {
                                myCars.map((myCar, k) => (
                                    <ListItem key={k} className="dashboard-portion-item dashboard-vehicle-list">
                                        <VehicleCardFromView itemview={myCar} driver={myEmployment} />
                                    </ListItem>
                                ))
                            }
                        </List>
                    </Box>
                )
            }

            {
                myDocuments &&
                Object.keys(myDocuments).length > 0 &&
                Object.values(myDocuments).some(value => !Array.isArray(value) && Object.keys(value).length > 0) && (
                    <Box className="dashboard-portion">
                        <Box className="dashboard-portion-title">{t('Your documents')}</Box>

                        <List className="dashboard-documents-list-wrapper">
                            {
                                Object.entries(myDocuments).map(([section, value]) => (
                                    Object.keys(value).length > 0 && (
                                        <ListItem key={section} className="dashboard-documents-list-section">
                                            <Box className="dashboard-documents-list-section-title">{section == 'person' ? myPerson?.firstname + " " + myPerson?.lastname : t('Vehicle') + " " + section}</Box>
                                            <List className="dashboard-documents-list-section-list">
                                                {
                                                    Object.entries(value).map(([k, document]) => (
                                                        <ListItem key={k} className="dashboard-documents-list-section-list-element">
                                                            <DocumentAvatar document={document} />
                                                        </ListItem>
                                                    ))
                                                }
                                            </List>
                                        </ListItem>
                                    )
                                ))
                            }
                        </List>
                    </Box>
                )
            }

            {
                myServices &&
                Object.keys(myServices).length > 0 &&
                Object.values(myServices).some(value => !Array.isArray(value) && Object.keys(value).length > 0) && (
                    <Box className="dashboard-portion">
                        <Box className="dashboard-portion-title">{t('Your services')}</Box>
                        <List className="dashboard-services-list-wrapper">
                            {
                                Object.entries(myServices).map(([section, value]) => (

                                    Object.keys(value).length > 0 && (
                                        <ListItem key={section} className="dashboard-services-list-section">
                                            <Box className="dashboard-services-list-section-title">{section == 'person' ? myPerson?.firstname + " " + myPerson?.lastname : t('Vehicle') + " " + section}</Box>
                                            <List className="dashboard-services-list-section-list">
                                                {
                                                    Object.entries(value).map(([k, service]) => (
                                                        <ListItem key={k} className="dashboard-services-list-section-list-element">
                                                            <ServiceAvatar service={service} />
                                                        </ListItem>
                                                    ))
                                                }
                                            </List>
                                        </ListItem>
                                    )
                                ))
                            }
                        </List>
                    </Box>
                )
            }

        </Box>
    )

}

export default Driver;


